/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/AffiliateItem/theme';

export const AffiliateItemTheme = theme;
